import Vue from 'vue'
import MessageBox from '../components/MessageBox.vue'

// 创建Vue子类实例
const MessageBoxConstructor = Vue.extend(MessageBox)

// 存储实例
let instance = null

// 显示消息框
const showMessageBox = (options) => {
  // 如果已有实例，先销毁
  if (instance) {
    instance.$destroy()
    instance.$el.remove()
  }

  // 创建新实例
  instance = new MessageBoxConstructor({
    el: document.createElement('div')
  })

  // 设置属性
  if (typeof options === 'string') {
    instance.message = options
    instance.title = ''
    instance.type = 'info'
  } else {
    instance.message = options.message || ''
    instance.title = options.title || ''
    instance.type = options.type || 'info'
  }

  // 添加到DOM
  document.body.appendChild(instance.$el)

  // 显示
  Vue.nextTick(() => {
    instance.visible = true
  })
}

// 全局alert方法
const alert = (message, title = '', type = 'info') => {
  if (typeof message === 'object') {
    showMessageBox(message)
  } else {
    showMessageBox({ message, title, type })
  }
}

// 导出常用方法
alert.info = (message, title = '') => alert(message, title, 'info')
alert.success = (message, title = '') => alert(message, title, 'success')
alert.warning = (message, title = '') => alert(message, title, 'warning')
alert.error = (message, title = '') => alert(message, title, 'error')

export default alert
